<ng-container *ngIf="reserveAmount$ | async as reserveAmount">
  <div
    nz-tooltip
    [nzTooltipTitle]="'AUCTION.TOTAL_HOLD_AMOUNT_FULL_INFO' | translate"
    nzTooltipOverlayClassName="skiptranslate"
  >
    {{ 'AUCTION.TOTAL_HOLD_AMOUNT' | translate }}

    <i
      nz-icon
      nzType="question-circle"
      nzTheme="outline">
    </i>
  </div>

  <nz-spin [nzSpinning]="loading$ | async">
    <app-currency
      class="price-container"
      [value]="reserveAmount"
      [exchangeRate]="exchangeRate"
      layout="vertical">
    </app-currency>
  </nz-spin>
</ng-container>